import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DateTimeInfo } from '@shared/types';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'date-and-time',
    standalone: true,
    imports: [TooltipModule],
    templateUrl: './date-and-time.component.html',
    styleUrl: './date-and-time.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateAndTimeComponent {
    dateTime = input.required<DateTimeInfo | null | undefined>();
    showTime = input<boolean>(false);
    dateOnly = input<boolean>(false);

    showTooltip = computed(() => !this.dateTime()?.time || this.showTime());

    dateOnlyIndicator = computed(() => {
        const date = this.dateTime()?.date || '';
        const splittedDate = date?.split(' @');
        return splittedDate?.length > 1 ? splittedDate[0] : date || '-';
    });
}
